import {
	SocialNetwork,
	Address,
	Translate,
	SelectOption,
	SelectableAddress
} from 'Types';

export enum BusinessPartnerProfileStatus {
	Registration = 0,
	NoSubscription = 1,
	Active = 2,
	Expired = 3
}

export enum PartnershipRequestStatus {
	PendingApproval = 0,
	Approved = 1,
	Rejected = 2,
	AutoRejected = 3
}

export interface BusinessPartnerMe {
	primarySubscriptionId: string;
	paymentMethods: [
		{
			paymentMethodId: string;
			title: string;
			type: string;
		}
	];
	businessSectorInfo: {
		businessSectorId: {
			value: string;
		};
		code: string;
		title: string;
	};
	id: string;
	businessName: string;
	providerCustomerId: string;
	webSiteAddress: string;
	taxNumber: string;
	hrEmailAddress: string;
	slogan: string;
	logo: Logo;
	description: string;
	businessPartnerProfileId: string;
	registrationInfo: {
		lastUpdatedAt: string;
		referralCommunityPartnerId: string;
		startedAt: string;
		status: number;
	};
	firstName: string;
	lastName: string;
	publishInfo: {
		version: number;
		lastUpdatedAt: string;
		status: number;
	};
	mainEmailAddress: string;
	agentId: string;
	slugUrl: string;
	address: Address;
	status: number;
	regionCode: string;
}

export interface UpdateBusinessPartnerProfile {
	businessName: string;
	sectorCode: string;
	firstName: string;
	lastName: string;
	taxNumber: string;
	webSiteAddress: string;
	mainEmailAddress: string;
	address: Address;
	slogan: string;
	description: string;
	hrEmailAddress: string;
}

export interface BusinessPartnerProfileInitialData extends BusinessPartnerMe {
	sectorCode: string;
}

export interface BusinessPartnerProfileData extends BusinessPartnerMe {
	sectorCode: SelectOption | undefined | null;
}

export interface BusinessPartnerProfileFormData extends BusinessPartnerMe {
	sectorCode: string;
}

export interface BusinessPartnerHeader {
	headerImage: Logo;
	logo: Logo;
	headerTitle: string;
	slogan: string;
	description: string;
	themeColor: number;
}

export interface BusinessPartnerProfile {
	id: string;
	businessPartnerId: string;
	header: BusinessPartnerHeader;
	version: number;
	benefitList: string[];
	benefitItems: string[];
	socialNetworks: SocialNetwork[];
	auditInfo?: {
		createdBy: string;
		createdAt: string;
		updatedBy: string;
		updatedAt: string;
	};
	contactPerson: {
		address: string;
		description: string;
		email: string;
		fullName: string;
		image: Logo;
		phoneNumber: string;
		position: string;
	};
	statistics: {
		enabled: boolean;
	};
	employee: {
		enabled: boolean;
		headline: string;
	};
	jobs: {
		enabled: boolean;
		headline: string;
	};
	jobAds: {
		enabled: boolean;
		headline: string;
		description: number;
	};
	internships: {
		enabled: boolean;
		headline: string;
	};
	benefits: {
		enabled: boolean;
		headline: string;
		description: string | number;
	};
	gallery: {
		title: string;
		showInHomePage: boolean;
	};
	statisticItems: Statistic[];
	galleryItems: [
		{
			url: string;
			thumbnail: string;
		}
	];
}

export interface PaymentMethod {
	paymentMethodId: string;
	title: string;
	type: string;
	brand: string;
	last4: string;
	expMonth: string;
	expYear: string;
	email: string;
}

export interface Logo {
	url: string;
	thumbnail: string;
}

export interface businessPartnerLogo {
	logo: Logo;
}

export interface Statistic {
	branch: string;
	establishedDate: string;
	location: string;
	employeeNumber: string;
}

export interface Benefit {
	id: string;
	code: string;
	title: string;
	translateTitles: Translate[];
	isActive: boolean;
}

export interface Statistic {
	id: string;
	title: string;
	text: string;
	icon: string;
	isActive: boolean;
}

export interface Gallery {
	url: string;
	thumbnail: string;
}

export interface Employee {
	id: string;
	fullName: string;
	description: string;
	isActive: boolean;
	jobPosition: string;
	showInHomePage: boolean;
	companyId?: string;
	image: { thumbnail: string; url: string } | null;
}

export interface EmployeeForm {
	image: { thumbnail: string; url: string } | null;
	fullName: string;
	description: string;
	jobPosition: string;
	isActive: boolean;
	showInHomePage: boolean;
}

export interface Branch {
	id: string;
	businessPartnerId: string;
	name: string;
	state?: SelectOption | null;
	countryName?: SelectOption | null;
	shortDescription: string;
	address: SelectableAddress;
	active: boolean;
}

export interface Activity {
	id: string;
	code: string;
	isActive: boolean;
	activityTranslates: Translate[];
}

export interface JobType {
	id: string;
	code: string;
	isActive: boolean;
	jobKind: number;
	jobTypeTranslates: Translate[];
}

export interface Sector {
	id: string;
	code: string;
	title: string;
	isActive: boolean;
	translates: Translate[];
}

export interface LinkedinConfig {
	clientIdentify?: string;
	clientSecret?: string;
	token?: string;
}
